import store from '@/store'

export default {
  install(Vue, opts = {}) {
    Vue.prototype.$checkDenied = permissionName => {
      return (
        (store.getters.user && store.getters.user.is_superuser) ||
        store.getters.userSelfPermissions.includes(permissionName)
      )
    }

    Vue.prototype.$checkPermission = deniedName => {
      return (
        (store.getters.user && store.getters.user.is_superuser) ||
        store.getters.userSelfPermissions.includes(deniedName)
      )
    }
  },
}
